/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./keyValueEditor.vue?vue&type=template&id=4aff2854&scoped=true&"
import script from "./keyValueEditor.vue?vue&type=script&lang=js&"
export * from "./keyValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./keyValueEditor.vue?vue&type=style&index=0&id=4aff2854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff2854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTextField,VTooltip})
